module.exports = __webpack_public_path__ + "static/media/medical_support.2fbab86c.svg";